import { graphql } from '../../__generated__';

export const CANCEL_ORDER = graphql(`
  mutation CancelOrder($orderId: ID!) {
    cancelOrder(orderId: $orderId)
  }
`);
